import { POST_LOGIN_START } from '../../types';

export const login = (payload) => ({
  type: POST_LOGIN_START,
  payload,
});
